import { session } from '@/helpers/auth';

/**
 * Retorna los headers de autorización para cada petición GraphQL.
 * Se ejecuta de forma lazy en cada request para obtener el token actualizado.
 */
export async function getGraphQLHeaders(): Promise<Record<string, string>> {
  return {
    Authorization: session() ?? '',
  };
}